import { useContext, useEffect, useRef } from "react";
import { WorkoutContext } from "../contexts/WorkoutContext";
import { useUserProfile } from "../contexts/UserProfileContext";
import { useToast } from "../contexts/ToastContext";
import { computeWeeklyTargets } from "../utils/weeklyTargets";

const SHOWN_KEY = "khronos_older_strength_notice_shown";
const DISMISSED_KEY = "olderStrengthSuggestionDismissed";

const readFlag = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw === "1" || raw === "true";
  } catch {
    return false;
  }
};

/**
 * Tells the user, once, that there's a suggestion for their weekly targets
 * (strength on 3+ days from 65). The suggestion itself lives on the Activity
 * card, where it can be accepted or dismissed; this only points to it.
 */
export function useTargetSuggestionNotice() {
  const { userProfile, setView } = useContext(WorkoutContext);
  const { sessions } = useUserProfile();
  const { showToast } = useToast();
  const shown = useRef(false);

  useEffect(() => {
    if (shown.current || readFlag(SHOWN_KEY) || readFlag(DISMISSED_KEY)) return;
    const { olderAdultSuggestion } = computeWeeklyTargets({
      userProfile,
      trainingDates: (sessions || []).map((s) => s.started_at),
    });
    if (!olderAdultSuggestion) return;
    shown.current = true;
    try {
      localStorage.setItem(SHOWN_KEY, "1");
    } catch {
      /* storage disabled: it may show again next launch, which is harmless */
    }
    showToast({
      title: "A suggestion for your weekly targets",
      description:
        "From 65, WHO advises strength and balance work on 3 or more days a week. You can raise your strength target on the Activity tab.",
      duration: 12000,
      action: { label: "View", onClick: () => setView?.("activity") },
    });
  }, [userProfile, sessions, showToast, setView]);
}

export default useTargetSuggestionNotice;
